module.exports = __webpack_public_path__ + "static/media/subtract 4.9124f5eb.webp";